import { Component, OnInit } from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from "../../services/data.service"
import { MasterService } from "../../services/inventory/master.service";

export interface ItemsMaster {
  title: string;
  Items: any;
  isDateTime: boolean;
}

@Component({
  selector: 'app-promotiondiscountaddbulk',
  templateUrl: './promotiondiscountaddbulk.component.html',
  styleUrls: ['./promotiondiscountaddbulk.component.css']
})
export class PromotionDiscountAddBulkComponent extends DialogComponent<ItemsMaster, boolean>
  implements ItemsMaster, OnInit {

  title: string;
  Items: any;
  isDateTime: boolean;
  result: any = { result: false, RtnItem: {} };
  loading: boolean = false;
  model = new DiscountDetails();
  dateformat: string = "yyyy-MM-dd";
  datetype: string = "date";
  promo_model = new Promo_Model();
  promo_List: Promo_Model[] = [];

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    if (this.isDateTime) {
      this.dateformat = "yyyy-MM-ddTHH:mm";
      this.datetype = "datetime-local";
    }
    else {
      this.dateformat = "yyyy-MM-dd";
      this.datetype = "date";
    }
    this.clear();
    this.loadItems();
  }

  clear() {
    this.model = new DiscountDetails();
    this.promo_model = new Promo_Model();
    this.promo_List = [];
    this.loading = false;
  }

  loadItems() {
    this.promo_List = [];
    for (let i of this.Items) {
      this.promo_model = new Promo_Model();
      this.promo_model.Barcode = i.Barcode;
      this.promo_model.ItemName = i.ItemName;
      this.promo_model.UnitName = i.Unit;
      this.promo_model.FromDate = this.model.FromDate;
      this.promo_model.ToDate = this.model.ToDate;
      this.promo_model.OrgSellingPrice = Number(i.SellPrice);
      this.promo_model.NewSellingPrice = Number(i.Amount);
      if (Number(i.SellPrice) == 0) {
        this.promo_model.Discount = 0;
        this.promo_model.DiscountPerc = 0;
      }
      else {
        this.promo_model.Discount = Number(i.SellPrice - i.Amount);
        this.promo_model.DiscountPerc = Number((this.promo_model.Discount / i.SellPrice) * 100);
      }

      this.promo_List.push(this.promo_model);
    }
  }

  addItem() {
    for (let i of this.promo_List) {
      i.FromDate = this.model.FromDate;
      i.ToDate = this.model.ToDate;
    }
    this.result.result = true;
    this.result.RtnItem = this.promo_List;
    this.close();
  }

  fromdateKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.fromDateLeave();
    }
  }
  fromDateLeave() {
    document.getElementById("todate").focus()
  }

  toDateKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.toDateLeave();
    }
  }
  toDateLeave() {
    document.getElementById("DDiscount").focus()
  }

  discountKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.discountLeave();
    }
  }

  discountLeave() {
    if (this.model.Discount != 0) {
      for (let i of this.promo_List) {
        if (Number(i.OrgSellingPrice) == 0) {
          i.DiscountPerc = 0;
          i.NewSellingPrice = 0;
          i.Discount = 0;
        }
        else {
          i.DiscountPerc = this.model.Discount;
          i.NewSellingPrice = (Number(i.OrgSellingPrice) - (Number(i.OrgSellingPrice) * Number(i.DiscountPerc)) / 100);
          i.Discount = (Number(i.OrgSellingPrice) * Number(i.DiscountPerc) / 100);
        }

      }
    }
  }

}
class DiscountDetails {
  FromDate: Date = new Date();
  ToDate: Date = new Date();
  Discount: number = 0;
}
class Promo_Model {
  Barcode: string = ""
  ItemName: string = ""
  UnitName: string = ""
  FromDate: Date = new Date()
  ToDate: Date = new Date()
  OrgSellingPrice: number = 0.0
  NewSellingPrice: number = 0.0
  Discount: number = 0.0
  DiscountPerc: number = 0.0
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/promotiondiscountaddbulk/promotiondiscountaddbulk.component.ts